<template>
  <div class="Newdagre" style="position: relative;">
    <div style="position: absolute;top: 50%;right: 0px;transform: translate(-20%, -70%);">
      <div class="svg_success_1">

        <p><span></span>未处理</p>
      </div>
      <div class="svg_success_2">

        <p><span></span>进行中</p>
      </div>
      <div class="svg_success_3">

        <p><span></span>通过</p>
      </div>
      <div class="svg_success_4">

        <p><span></span>不通过</p>
      </div>
    </div>
    <div class="svg_img" id="zoom" @wheel.prevent="zoomMap"  v-drag="greet">

    </div>
    <!-- <svg class=""  /> -->

    <!-- <div class="chartTooltip">
      <p id="chartTooltipText">
        <span class="chartTooltip-textMoney"/>
      </p>
    </div> -->
  </div>
</template>

<script>
import * as d3 from 'd3'
import dagreD3 from 'dagre-d3'
export default {
  name: 'Newdagre',
  mounted() {
    this.initNodes();
  },
  props: { //用于封装组件的参数传递
        sid:{ // 业务主体对象ID
            type:String,
            required: true
        },
        bussinesscode:{
            type:String,
            required: true
        },
        projectid:{
          type:String,
            default:""
        },
    },
  data(){
    return{
      nodes :[],
      edges :[],
      zoomHandler: null,
      axises: {
        node: null,
        x: null,
        xScale: null,
        xContainer: null,
        y: null,
        yScale: null,
        yContainer: null
      },
      svg:null,
      params: { zoomVal: 1, left: 0, top: 0, currentX: 0, currentY: 0, flag: false },
      //流程图拖拽
      x:0,
      y:0,
      scalc:1,
      valxy:{x:0,y:0},
    }
  },
  methods: {
    greet(val){
      console.log('val',val)

      this.x+=val.x
      this.y+=val.y
      // this.valxy=val
      d3.select(".svg_img .output").attr('transform',"translate(" +this.x+" "+this.y+")  "+"scale(" + this.scalc + ")")
    },
    dragFn(e){
      console.log('e',e);
    },
    zoomMap(e) {
      // 兼容火狐
      const eventDelta = e.wheelDelta || -e.deltaY * 40;
      var map = document.getElementById("zoom");
      var params = this.params;
      params.zoomVal += eventDelta / 1200;
      if (params.zoomVal >= 0.1) {
        this.scalc=params.zoomVal.toFixed(2)
        d3.select(".svg_img .output").attr('transform',"translate(" +this.x+" "+this.y+")  "+"scale(" + this.scalc + ")")
        // map.style.transform = "scale(" + params.zoomVal.toFixed(2) + ")";
      } else {
        params.zoomVal = 0.1;
        this.scalc=params.zoomVal.toFixed(2)
        d3.select(".svg_img .output").attr('transform',"translate(" +this.x+" "+this.y+")  "+"scale(" + this.scalc + ")")
        // map.style.transform = "scale(" + params.zoomVal.toFixed(2) + ")";
        return false;
      }
      console.log("this.params", this.params.zoomVal.toFixed(2));


    },
    initNodes(){//初始化菜单信息
        let params = new URLSearchParams();
          params.append("recordObjectId",this.sid);
          params.append("bussinessCode",this.bussinesscode);
          params.append("projectId",this.projectid);
          this.$ajax.get(process.env.API_HOST+"approval-record-history/list", {params:params}).then((res) => {
            if(res && res.status == 200) {
                let resultData = res.data.data;
                let approvalNodes = resultData.approvalNodes;
              //两个相同的领导节点
              if(this.bussinesscode==='GOVP_TENDER_PROJECT' && JSON.stringify(approvalNodes).match(/集采部领导/g).length==2){
                for (let i = 0; i < approvalNodes.length; i++) {
                  if(approvalNodes[i].approvalUsers==='集采部领导'){
                    if(approvalNodes[i].level===2){
                      approvalNodes[i].approvalUsers='集采部领导(核验)'
                    }else if(approvalNodes[i].level===3){
                      approvalNodes[i].approvalUsers='集采部领导(分配)'
                    }
                  }
                }

              }

                let approvalRelationships = resultData.approvalRelationships;
                console.log(approvalNodes);
                console.log(approvalRelationships);
                this.dealNodes(approvalNodes);
                this.dealRelationships(approvalRelationships);
                console.log(this.nodes);
                console.log(this.edges);
                this.typeNode();
			} else {
			}
          })
    },
    dealNodes(approvalNodes){// 处理核验节点信息
        for(let i = 0; i < approvalNodes.length; i ++){
            let approvalNode = approvalNodes[i];
            let tempNode = {
                id: approvalNode.code,
                state: 'success_'+approvalNode.approvalStatus,
                value: {
                    label: approvalNode.approvalUsers,
                    operator: 'BashOperator'
                }
            };
            this.nodes[i]=tempNode;
        }
    },
    dealRelationships(approvalRelationships){// 处理核验流程关系信息
        for(let i = 0; i < approvalRelationships.length; i ++){
            let approvalRelationship = approvalRelationships[i];
            let tempRelationship = {
                from: approvalRelationship.startNode,
                to: approvalRelationship.endNode,
                label:approvalRelationship.relationshipDescribe
            };
            this.edges[i]=tempRelationship;
        }
    },
    typeNode() {                                              //整个图的方向
      const g = new dagreD3.graphlib.Graph().setGraph({ rankdir: 'LR' })
      // this.edges =[
      //     {from: "1#QY-GP-CGR", to: "end", label: null},
      //     {from: "1#GP-JCBLD", to: "end", label: null},
      //     {from: "start", to: "1#QY-GP-CGR", label: null},
      //     {from: "start", to: "1#GP-JCBLD", label: null},
      //   ]


      //   this.nodes =[
      //     {id: "1#QY-GP-CGR",
      //       state: "success",
      //       value: {label: "采购人-政采", operator: "BashOperator"}
      //     },
      //     {
      //       id: "1#GP-JCBLD",
      //       state: "success",
      //       value: {label: "集采部领导", operator: "BashOperator"}
      //     },
      //     {
      //       id: "start",
      //       state: "success",
      //       value: {label: "开始", operator: "BashOperator"}
      //     },
      //     {
      //       id: "end",
      //       state: "success",
      //       value: {label: "结束", operator: "BashOperator"}
      //     }
      //   ]


      // const states = {
      //   // 'circle': { shape: 'circle' },
      //   //                          节点    颜色
      //   Start: {  style: 'fill: #f77' },
      //   'JW002': { },
      //   'JW003': { },
      //   'JW004': { },
      //   // 'JW005': { shape: 'circle' },
      //   // 'JW006': { shape: 'circle' },
      //   // 'JW007': { shape: 'circle' },
      //   // 'JW008': { shape: 'circle' },
      //   // 'JW009': { shape: 'circle' },
      //   // 'JW010': { shape: 'circle' },
      //   // 'JW011': { shape: 'circle' },
      //   // 'JW012': { shape: 'circle' },
      //   // 'JW013': { shape: 'circle' },
      //   // 'JW014': { shape: 'circle' },
      //   // 'JW015': { shape: 'circle' },
      //   // 'JW016': { shape: 'circle' },
      //   'End': {  }
      // }

      //通过operator来画shape(BranchPythonMapOperator: 分支； JoinOperator：合流)
      this.nodes.forEach(

          (item) => {

              let state = item.state ? item.state : 'no-status'
              let shape = 'rect'
              // if (item.value.operator === 'BranchPythonMapOperator') {
              //     shape = 'ellipse'
              // } else if (item.value.operator === 'JoinOperator') {
              //     shape = 'circle'
              // }
              // if(item.state=="success_0" || item.state=="success_null" || item.approvalUsers=="开始"){
                // 圆形
              //   shape = 'ellipse';
              // }
              //ie内核 兼容 --火狐 ie 谷歌 mac 兼容
              var u = navigator.userAgent

              // item.id=='0'?item.id='start':(item.id=='-1'?item.id='end':'');     形状
              //height设置以30为基础  10的时候就是40
              g.setNode(item.id, {paddingRight:15,margin:0,paddingTop:u.indexOf('Trident') > -1?15:10,boxSizing:'border-box',label: item.value.label, shape: shape,rx:15,ry:15,y:-15, class: item.value.operator + ' dagre ' + state,height:u.indexOf('Trident') > -1?0:10})


              // d3.select(".label-container")

          }
      )

      // Object.keys(states).forEach(function(state) {
      //   const value = states[state]
      //   value.label = state
      //   value.padding = 10
      //   value.height = 30
      //   value.width = 100
      //   value.r = 15
      //   value.rx = value.ry = 5
      //   // 设置所有节点
      //   g.setNode(state, value)
      // })
      //              前点       后点      线值
      // g.setEdge('circle', 'JW002', { label: '001 ', lineInterpolate: 'basis' })
      //设置所有节点位置
      // g.setEdge('Start', 'JW002', {  lineInterpolate: 'basis' })


      // g.setEdge('JW002', 'JW003', {  lineInterpolate: 'basis' })
      // g.setEdge('JW002', 'JW004', {  lineInterpolate: 'basis' })

      // g.setEdge('JW003', 'End', {  lineInterpolate: 'basis' })
      // g.setEdge('JW004', 'End', {  lineInterpolate: 'basis' })
       this.edges.forEach(
            (item) => {
                // item.from=='0'?item.from='start':(item.from=='-1'?item.from='end':'');
                // item.to=='0'?item.to='start':(item.to=='-1'?item.to='end':'');
                if (item.label) {
                                                    // label: item.label,
                    g.setEdge(item.from, item.to, {lineInterpolate: 'basis' })
                } else {
                    g.setEdge(item.from, item.to,{  lineInterpolate: 'basis' })
                }
            }
        )
      console.log('this.nodes',this.nodes);
      console.log('this.edges',this.edges);


      const render = dagreD3.render()
      // const svg = d3.select('.svg_img')
      // const inner = svg.append('svg')

      this.svg = d3.select(".svg_img")
            .append("svg")
            // .attr("preserveAspectRatio", "xMinYMid meet")
            .attr("viewBox", "0 -20 " + this.nodes.length * 120 +" 240")
            // .call(d3.zoom().on("zoom", function () {
            //    d3.select(".svg_img").select('svg').attr("transform", "translate(" + d3.event.translate + ")" + " scale(" + d3.event.scale + ")")
            // }))

      console.log('render',dagreD3)

      console.log('g',d3)
      render(this.svg, g)
      this.zoomMap()
      // 设置画布大小
      // d3.select('svg').select('svg').attr("preserveAspectRatio", "xMidYMid meet")
      //       .attr("viewBox", "0 0 400 400")
      // this.addZoomBehavior()


    },
    addZoomBehavior () {
      this.zoomHandler = d3.zoom()
        .scaleExtent([0.1, 10]) // zoom limit
        .translateExtent([[-100, -100], [this.width + 90, this.height + 100]]) // translate limit
        .on('svg_img', () => {
          this.svgGraphContainer.attr('transform', d3.event.transform)
          this.axises.xContainer.call(this.axises.x.scale(d3.event.transform.rescaleX(this.axises.xScale)))
          this.axises.yContainer.call(this.axises.y.scale(d3.event.transform.rescaleY(this.axises.yScale)))
        })
      this.svg.call(this.zoomHandler)
    },
  }
}
</script>
<style lang="scss">
.svg_img{
  width: calc(100% - 100px);
  height: 200px;
  >svg{
    width: 100%;
    height: 100%;
  }
}
/*流程图颜色*/
.edgePath path {
  stroke: #333;
  fill: #fff;
  stroke-width: 1.5px;
}
/************ 图表变量 ***************/
/*#ffc107 f77d6b*/
$fail: #ffc107;
$success: #61b2e4;
$running: #87d86f;
$skipped: #faec91;
$queued: #43e3ed;
$retry: #f8b96c;
$no-status: #fff;
$upstream_failed: rgb(163, 108, 108);

$state_1:#1590fe;
$state_2:#e5e5e5;
$state_3:#57b505;
$state_4:#ff4b53;
/**************** dagre 节点图************************/
.svg_success_1{
  >p{
    text-indent: 20px;
    >span{
      display: inline-block;
      vertical-align: middle;
      width: 11px;
      height: 11px;
      margin-right: 5px;
      border-radius: 50%;
      background:$state_2 ;

    }
  }

}
.svg_success_2{
  >p{
    text-indent: 20px;
    >span{
      display: inline-block;
      vertical-align: middle;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: $state_1;
      margin-right: 5px;
    }
  }
}
.svg_success_3{
  >p{
    text-indent: 20px;
    >span{
      display: inline-block;
      vertical-align: middle;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background:$state_3;
      margin-right: 5px;
    }
  }
}
.svg_success_4{
  >p{
    text-indent: 20px;
    >span{
      display: inline-block;
      vertical-align: middle;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background:$state_4;
      margin-right: 5px;
    }
  }
}

g.node.dagre {
    rect{
      height: 30px!important;
      y: -15;
    }
    tspan {
        fill: #fff;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
    }
    &.no-status {
        rect {
            stroke: #333;
            fill: #fff;
        }
        ellipse {
            stroke: #333;
            fill: #fff;
        }
        circle {
            stroke: #333;
            fill: #fff;
        }
        tspan {
            fill: #333;
        }
    }
    /*开始结束*/
    &.success_0 {
        rect {
            stroke: #fff;
            fill: $success;
        }
        ellipse {
            stroke: #fff;
            fill: #b8b2b1;
        }
        circle {
            stroke: #fff;
            fill: $success;
        }
    }
    &.success_null {
        rect {
            stroke: #fff;
            fill: $success;
        }
        ellipse {
            stroke: #fff;
            fill: $success;
        }
        circle {
            stroke: #fff;
            fill: $success;
        }
    }
    /*进行中*/
    &.success_1 {
        tspan {
          fill: #000;

        }
        rect {
            stroke: #fff;
            fill: $state_2;
        }
        ellipse {
            stroke: #fff;
            fill: $state_2;
        }
        circle {
            stroke: #fff;
            fill: $state_2;
        }
    }
    /*未处理*/
    &.success_2 {
        tspan {
          fill: #fff;

        }
        rect {
            stroke: #fff;
            fill: $state_1;
        }
        ellipse {
            stroke: #fff;
            fill: $state_1;
        }
        circle {
            stroke: #fff;
            fill: $state_1;
        }
    }
    /*通过*/
    &.success_3 {
        rect {
            stroke: #fff;
            fill: $state_3;

        }

        ellipse {
            stroke: #fff;
            fill: $state_3;
        }
        circle {
            stroke: #fff;
            fill: $state_3;
        }
    }
    .success_3::before{
      content: '2000';
      font-size: 16px;
      color: red;
    }
    /*不通过*/
    &.success_4 {
        rect {
            stroke: #fff;
            fill: $state_4;

        }
        ellipse {
            stroke: #fff;
            fill: $state_4;
        }
        circle {
            stroke: #fff;
            fill: $state_4;
        }
    }

    &.skipped {
        rect {
            stroke: #fff;
            fill: $skipped;
        }
        ellipse {
            stroke: #fff;
            fill: $skipped;
        }
        circle {
            stroke: #fff;
            fill: $skipped;
        }
    }
    &.queued {
        rect {
            stroke: #fff;
            fill: $queued;
        }
        ellipse {
            stroke: #fff;
            fill: $queued;
        }
        circle {
            stroke: #fff;
            fill: $queued;
        }
    }
    &.BashOperator {
        /*&:hover {
            & > rect {
                cursor: pointer;
                fill: #7cc9fa;
            }
        }*/
    }
    &.BranchPythonMapOperator {
        /*&:hover {
            & > ellipse {
                cursor: pointer;
                fill: #c52bd3;
            }
        }*/
    }
    &.JoinOperator {
       /* &:hover {
            & > circle {
                cursor: pointer;
                fill: #0beb8d;
            }
        }*/
    }
}
.zoom {
    margin-left: 40px;
}



.Newdagre{
  width: 100%;
  height: 100%;
  /*display: flex;*/
  position: relative;
  >svg{
    display: block;
    /*margin:0 auto;*/
    width: 100%;
  }
}

/*.Newdagre svg{
  width: 800px;
  height: 200px;
}*/

.Newdagre .node rect {
  stroke: #333;
  fill: #fff;
}

.Newdagre .edgePath path {
  stroke: #333;
  fill: #fff;
  stroke-width: 1.5px;
}

.Newdagre .node circle{
  fill: #333;
}


.chartTooltip {
  position: absolute;
  height: auto;
  padding: 10px;
  box-sizing: border-box;
  background-color: white;
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.4);
  opacity: 0;
}
.chartTooltip p {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  word-wrap: break-word;
}
.chartTooltip p span{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/lct.vue